<template>
	<div class="app-container">

		<div class="h1-buttons">
			<h1>Bonus</h1>
			<button class="btn btn-primary" @click="editBonus({})">New bonus</button>
		</div>
		
		<table class="table loading-container">
			<thead>
				<tr>
					<th scope="col">#</th>
					<th scope="col">Name</th>
					<th scope="col">Cents</th>
					<th scope="col"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(p, index) in bonuses.content" :key="index">
					<td>{{ index + 1 }}</td>
					<td>{{ p.key }}</td>
					<td>{{ p.cents }}</td>
					<td class="text-right">
						<button
							title="Edit"
							class="btn btn-secondary"
							@click="editBonus(p)"
						>
							<i class="fas fa-pen"></i>
						</button>
						<button
							title="Delete"
							class="btn btn-danger"
							@click="deleteBonus(p.id)"
						>
							<i class="fas fa-trash-alt"></i>
						</button>
					</td>
				</tr>
			</tbody>
			<tfoot>
				<tr v-if="bonuses && bonuses.content && !bonuses.content.length">
					<td colspan="4" class="nodata">
						<NoData />
					</td>
				</tr>
			</tfoot>
			<Spinner v-if="loading" />
		</table>
		<ErrorAlert v-if="errMessage" :error="errMessage" />
		<ErrorDialog ref="errDialog" />
		<BonusEditDialog ref="bonusEditDialog" v-on:save-success="loadBonuses" />
		<div class="pagination-row">
			<p v-if="bonuses && bonuses.content">
				A total of {{ bonuses.totalElements }} bonus listings. Showing results
				{{ currentSearch.page * currentSearch.size + 1 }} to
				{{
					currentSearch.size == bonuses.content.length
						? (currentSearch.page + 1) * currentSearch.size
						: (currentSearch.page + 1) * bonuses.content.length
				}}
			</p>
			<Pagination
				v-if="bonuses.totalPages > 1"
				:data="bonuses"
				v-on:page-selected="selectPage"
			/>
		</div>
	</div>
</template>

<script>
import BonusService from '../../services/bonus';
import Pagination from '../shared/Pagination';
import BonusEditDialog from './BonusEditDialog';
import Spinner from '../shared/Spinner';
import ErrorAlert from '../shared/ErrorAlert';
import ErrorDialog from '../shared/ErrorDialog';
import NoData from '../shared/NoData';

export default {
	name: 'Bonus',
	components: {
		Pagination,
		BonusEditDialog,
		ErrorAlert,
		ErrorDialog,
		Spinner,
		NoData,
	},
	data: function () {
		return {
			bonuses: {
				pageable: {
					pageNumber: 0,
					pageSize: 10,
				},
				totalElements: 0,
			},
			currentSearch: {
				page: 0,
				size: 10,
			},
			errMessage: null,
			loading: true,
		};
	},
	mounted() {
		this.searchBonuss();
	},
	methods: {
		searchBonuss: function (search = { page: 0, size: 10 }) {
			this.currentSearch = search;
			this.loading = true;
			BonusService.instance()
				.searchBonus(search)
				.then((data) => {
					this.loading = false;
					this.bonuses = data.data;
				})
				.catch((error) => {
					this.loading = false;
					this.errMessage = error;
				});
		},
		loadBonuses: function () {
			this.searchBonuss(this.currentSearch);
		},
		selectPage: function (page) {
			this.searchBonuss({ page: page - 1, size: 10 });
		},
		editBonus(bonus) {
			this.$refs.bonusEditDialog.show(bonus);
		},
		deleteBonus(id) {
			BonusService.instance()
				.deleteBonus(id)
				.then(() => {
					this.searchBonuss(this.currentSearch);
				})
				.catch((error) => {
					this.$refs.errDialog.show(error);
				});
		},
	},
};
</script>

<style>
.loading-container {
	position: relative;
}
td.nodata {
	vertical-align: middle;
}
</style>
